// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"49":"a5552972","186":"f35261d1","590":"a5552972","755":"a5552972","811":"a5552972","907":"a5552972","910":"a5552972"}[chunkId] + ".chunk.css";
};